<template>
  <svg
    class="icon-chevron-down"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6.000979900360107 9.47216510772705 12.027088165283203 7.152035713195801"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.32999 9.83023C6.54092 9.61955 6.82686 9.50122 7.12499 9.50122C7.42311 9.50122 7.70905 9.61955 7.91999 9.83023L12 13.9102L16.08 9.83023C16.183 9.7197 16.3072 9.63105 16.4452 9.56956C16.5832 9.50807 16.7321 9.47501 16.8832 9.47234C17.0343 9.46968 17.1843 9.49746 17.3244 9.55405C17.4645 9.61063 17.5917 9.69484 17.6985 9.80167C17.8054 9.9085 17.8896 10.0358 17.9462 10.1758C18.0028 10.3159 18.0305 10.466 18.0279 10.617C18.0252 10.7681 17.9921 10.917 17.9307 11.055C17.8692 11.193 17.7805 11.3172 17.67 11.4202L12.795 16.2952C12.584 16.5059 12.2981 16.6242 12 16.6242C11.7019 16.6242 11.4159 16.5059 11.205 16.2952L6.32999 11.4202C6.11931 11.2093 6.00098 10.9234 6.00098 10.6252C6.00098 10.3271 6.11931 10.0412 6.32999 9.83023Z"
    />
  </svg>
</template>

<style scoped>
  .icon-chevron-down {
    overflow: visible;
  }
</style>
